import { Box, Flex, Link, useColorMode } from '@chakra-ui/react';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { colors } from 'packages/common-frontend/colors';

export const HEADER_HEIGHT = 84;

export const Header: React.FC<{
  logoImage: React.ReactElement;
  // @jendevelops TODO: remove this prop once Goldman Sachs specific router removed (after deliverable trial period ends)
  isDisabled?: boolean;
}> = ({ children, logoImage, isDisabled = false }) => {
  const { colorMode } = useColorMode();
  return (
    <Flex
      as="nav"
      align="center"
      justify="space-between"
      wrap="wrap"
      padding={{ base: '15px 20px', lg: '15px 30px' }}
      borderBottom={`1px solid ${colors.gray['200']}`}
      boxShadow="0 0 4px hsl(0deg 0% 76% / 35%)"
      color="black"
      w="100%"
      h={HEADER_HEIGHT}
      position="fixed"
      backgroundColor={colorMode === 'light' ? 'white' : 'black'}
      zIndex="sticky"
    >
      <Box>
        {isDisabled ? (
          logoImage
        ) : (
          <Link as={RouterLink} to="/">
            {logoImage}
          </Link>
        )}
      </Box>
      <Box>{children}</Box>
    </Flex>
  );
};
